module.exports = __webpack_public_path__ + "img/banner_auto.6f0a1479.png";